import * as models from 'smg/customer-api/models';

export function CapitalizeFirstLetter(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function NumberToPaymentOptionTypeID(num: number): models.PaymentOptionTypeID | undefined {
    if (models.IsPaymentOptionTypeID(num)) {
        return num;
    }
    return undefined;
}

export function PaymentOptionTypeIDtoName(id?: models.PaymentOptionTypeID, short = false): string {
    if (short) {
        switch (id) {
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT:
            return 'cc';
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PAY_PAL:
            return 'paypal';
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO:
            return 'po';
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CHECK:
            return 'check';
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_WIRE:
            return 'wire';
        case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK:
            return 'bank';
        default:
            return 'unknown';
        }
    }
    switch (id) {
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT:
        return 'Credit/Debit Card';
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PAY_PAL:
        return 'PayPal';
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO:
        return 'Purchase Order';
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CHECK:
        return 'Check';
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_WIRE:
        return 'Wire Transfer';
    case models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK:
        return 'Bank Account';
    default:
        return 'unknown';
    }
}
